export enum FlagUseModeCode {
  Elettorale = '4',
  Certificazione = '1',
  StatoCivile = '3',
}
